import React, { createContext, useContext, useState, useEffect } from 'react';
import { useThemeContext } from 'contexts/ThemeContext';
import { DOCTYPE_STATUS } from './constants';
import { ExpertiseService } from './service';

const MotoContext = createContext();

export const useMotoContext = () => useContext(MotoContext);

export default ({ children }) => {
  const path = window.location.pathname;
  const company = path.includes('gic') ? 'gic' : 'liberty';
  const { changeMainColor } = useThemeContext();

  // Sử dụng boolean hoặc counter nhưng đặt tên rõ ràng
  const [loadingCount, setLoadingCount] = useState(0);
  const handleLoading = (loading = true) => {
    setLoadingCount((prev) => (loading ? prev + 1 : Math.max(0, prev - 1)));
  };

  const [informationParams, setInformationParams] = useState(null);
  const [codeSnippet, setCodeSnippet] = useState(null);
  const [photoItems, setPhotoItems] = useState([]);
  const [photoBonusItems, setPhotoBonusItems] = useState([]);
  const [messages, setMessages] = useState([]);
  const [typeMsg, setTypeMsg] = useState(null);
  const [inforCar, setInforCar] = useState({});
  const [isFetchDataDone, setFetchDataDone] = useState(false);
  const [isConfirmCheckout, setConfirmCheckout] = useState(false);
  const [isLoadingConfig, setLoadingConfig] = useState(false);

  useEffect(() => {
    if (!codeSnippet) return;
    changeMainColor('#1A1446', '#fff');
    fetchInitialData();
  }, [codeSnippet]);

  function handleError(err) {
    const message = err?.message || `Lỗi network ${err?.status || ''}`;
    setMessages([{ message }]);
    setTypeMsg('error');
  }

  const fetchInitialData = async () => {
    setLoadingConfig(true);
    try {
      // 1. Get Info Car
      const resCar = await ExpertiseService.getInfoCar(company, codeSnippet);
      const {
        engineNumber,
        LicenseNumber,
        Make,
        Model,
        InsurerBranchId,
        btn_bg_color,
        btn_text_color,
        chassisNumber,
        ppi_confirm,
        OrderId,
      } = resCar.data;

      changeMainColor(btn_bg_color, btn_text_color);
      setInforCar(resCar.data);
      setConfirmCheckout(ppi_confirm === 'Y');
      setInformationParams({
        licenseNumber: LicenseNumber,
        make: Make,
        model: Model,
        engineNumber: engineNumber,
        insurerBranchId: InsurerBranchId,
        chassisNumber: chassisNumber,
      });

      // 2. Get Doctype (Sequential dependency on OrderId & BranchId)
      if (OrderId) {
        const resDoc = await ExpertiseService.getDoctype(company, OrderId, InsurerBranchId);
        const doctype = resDoc.data;
        const mappedDocs = doctype.map((x, index) => ({
          ...x,
          image: null,
          imageSample: x.image,
          status: DOCTYPE_STATUS.IDLE,
          statusText: '',
          index: index + 1,
          uploadPercentage: 0,
          cancel: null,
        }));
        setPhotoItems(mappedDocs.filter((x) => x.required));
        setPhotoBonusItems(mappedDocs.filter((x) => !x.required));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoadingConfig(false);
      setFetchDataDone(true);
    }
  };

  return (
    <MotoContext.Provider
      value={{
        setCodeSnippet,
        loading: loadingCount > 0,
        handleLoading,
        photoItems,
        setPhotoItems,
        messages,
        typeMsg,
        setTypeMsg,
        inforCar,
        handleError,
        isFetchDataDone,
        informationParams,
        isConfirmCheckout,
        loadingConfig: isLoadingConfig,
        photoBonusItems,
        setPhotoBonusItems,
      }}
    >
      {children}
    </MotoContext.Provider>
  );
};
